import { authVar, userDeatils, schoolDtls } from '../RactiveVariables';

export const logout = () => {
  // Get current user data before clearing
  const user = userDeatils();
  
  // Clear localStorage
  localStorage.removeItem('@authToken');
  
  // Reset reactive variables
  authVar({
    loaded: true,
    auth: false,
    userType: null,
  });
  
  userDeatils({
    data: null,
  });
  
  schoolDtls({
    data: null,
  });
  
  // Redirect to appropriate login page based on user type
  if (user?.data?.loginType === "Admin") {
    window.location.href = '/login';
  } else {
    window.location.href = "/schoollogin";
  }
};
